export default function SettingsExport() {
  return (
    <div>
      <h2 className="section-title mb-4">Data &amp; export</h2>

      <div className="card card-pad">
        <p className="muted">
          A weekly backup dumps the key tables — weigh-ins, workouts, and coaching
          notes — to R2 as JSON, so your history is never trapped in one place.
        </p>
        <p className="muted mt-3">
          On-demand CSV export is coming once the export endpoint is wired up. For
          now the weekly JSON snapshot is the source of truth.
        </p>
        <div className="mt-5">
          <button type="button" className="btn-secondary" disabled>
            Export CSV (coming soon)
          </button>
        </div>
      </div>
    </div>
  )
}
